import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/search.png';
import _imports_1 from '../../assets/image/zan.png';
import _imports_2 from '../../assets/image/look.png';
import _imports_3 from '../../assets/image/commont.png';
const _withScopeId = n => (_pushScopeId("data-v-56eb2f26"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "forums"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "log"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "/forumSearch"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})])], -1));
const _hoisted_3 = {
  class: "van_tabs"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "forum"
};
const _hoisted_6 = {
  class: "list"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "dmbp_user_l"
};
const _hoisted_9 = {
  class: "logo"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "info"
};
const _hoisted_12 = {
  class: "title"
};
const _hoisted_13 = {
  class: "tiems"
};
const _hoisted_14 = {
  class: "titles"
};
const _hoisted_15 = ["innerHTML"];
const _hoisted_16 = {
  class: "user_info"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1));
import nav_header from '@/components/nav_header.vue';
import swipers from '@/components/swipers.vue';
import release from '@/components/release.vue';
import { article_type, article_index, article_add } from '../../util/http.js';
import { showToast } from 'vant';
import 'vant/es/toast/style';

import { useRouter } from 'vue-router';
import { ref, reactive, onBeforeMount } from 'vue';
export default {
  __name: 'forum',
  setup(__props) {
    const router = useRouter();
    const loading = ref(false);
    const finished = ref(false);
    let page = ref(1);
    let typeId = ref('1');
    let activeIndex = ref(0);
    let left = ref('100');
    let releasc = () => {
      left.value = '0';
    };
    let returnUp = () => {
      left.value = '100';
    };
    let submit = data => {
      articleAdd(data.title, data.content, data.id);
    };
    let articleAdd = (title, content, id) => {
      article_add({
        title: title,
        type: 1,
        content: content,
        type_id: id
      }).then(res => {
        if (res.code == '400') {
          showToast(res.message);
          return;
        }
        if (res.message == '请先登录!') {
          showToast(res.message);
        } else {
          showToast(res.message);
          left.value = '100';
        }
        location.reload();
      });
    };
    let typeList = ref([{
      name: '关注'
    }]);
    let datas = reactive({
      forumData: []
    });
    // let forumData = ref([
    //     {name:'快乐8资料大全',title:'2023106期:神算子解正掛成语OK',tiems:'2023-04-16 00:57:17',content:'【2023106期】挂牌成语：论黄数白[挂：26 爆：鸡]'},
    // ])
    let forumDesc = data => {
      router.push({
        path: `/detail/${data.id}/0`
      });
    };
    onBeforeMount(() => {
      article_type().then(res => {
        typeList.value = res.data;
        typeId.value = res.data[0].id;
        // articleIndex(typeId.value,1)
      });
    });

    let fnType = (id, index) => {
      datas.forumData.length = 0;
      activeIndex.value = index;
      page.value = 1;
      articleIndex(id, page.value);
    };
    let articleIndex = (id, page) => {
      article_index({
        type_id: id,
        page: page
      }).then(res => {
        let data = res.data.data;
        if (data.length == '0') {
          finished.value = true;
        } else {
          loading.value = false;
          data.forEach(item => {
            item.image = item.username.avatar;
            item.nickname = item.username.nickname;
            datas.forumData.push(item);
          });
        }
      });
    };
    const onLoad = () => {
      // let tims = setTimeout(()=>{
      articleIndex(typeId.value, page.value);
      page.value++;

      // },500)
    };

    return (_ctx, _cache) => {
      const _component_van_empty = _resolveComponent("van-empty");
      const _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(release, {
        onReleases: _unref(releasc),
        onReturnUp: _unref(returnUp),
        onSubmit: _unref(submit),
        left: _unref(left)
      }, null, 8, ["onReleases", "onReturnUp", "onSubmit", "left"]), _createVNode(nav_header, {
        name: "快乐8论坛"
      }, {
        more: _withCtx(() => [_hoisted_2]),
        _: 1
      }), _createVNode(swipers), _createElementVNode("div", _hoisted_3, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeList), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: _normalizeClass(_unref(activeIndex) == index ? 'active' : ''),
          key: index,
          onClick: $event => _unref(fnType)(item.id, index)
        }, _toDisplayString(item.name), 11, _hoisted_4);
      }), 128))])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_list, {
        loading: _unref(loading),
        "onUpdate:loading": _cache[0] || (_cache[0] = $event => _isRef(loading) ? loading.value = $event : null),
        finished: _unref(finished),
        "finished-text": "没有更多了",
        onLoad: onLoad
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_unref(datas).forumData.length == 0 ? (_openBlock(), _createBlock(_component_van_empty, {
          key: 0,
          style: {
            "margin-top": "100px"
          },
          description: "目前还没有帖子哦"
        })) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(_unref(datas).forumData, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "item",
            key: index,
            onClick: $event => _unref(forumDesc)(item)
          }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
            src: item.image,
            alt: "",
            srcset: ""
          }, null, 8, _hoisted_10)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("span", null, _toDisplayString(item.nickname), 1)]), _createElementVNode("div", _hoisted_13, _toDisplayString(item.create_time), 1)])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("p", null, _toDisplayString(item.title), 1)]), _createElementVNode("div", {
            class: "boxCont",
            innerHTML: item.content
          }, null, 8, _hoisted_15), _createElementVNode("div", _hoisted_16, [_createElementVNode("p", null, [_hoisted_17, _createElementVNode("span", null, _toDisplayString(item.good_count) + " 赞", 1)]), _createElementVNode("p", null, [_hoisted_18, _createElementVNode("span", null, _toDisplayString(item.browse.num), 1)]), _createElementVNode("p", null, [_hoisted_19, _createElementVNode("span", null, _toDisplayString(item.comment_count) + "评论", 1)])])], 8, _hoisted_7);
        }), 128))])]),
        _: 1
      }, 8, ["loading", "finished"])])]);
    };
  }
};